/* KIS sokken-upsell (live 2026-10-02; Dawn-versie 2026-10-20, ronde 10: lade verversen via cart-drawer.renderContents + secties,
   zoals kis-pages.js; het bestand was op 15 okt per ongeluk als 'dood' verwijderd terwijl snippets/kis-socks-upsell.liquid het laadt).
   Na het toevoegen van een sneaker (producttype sneakers/schoenen) en zonder sokken in de winkelwagen: elke keer
   de pop-up "Sokken erbij?" (sinds 2026-10-02 niet meer eenmalig per bezoek, niet bij Essentials/kleding). De pop-up voegt het verborgen deal-product toe (Shopify-bundel van de echte sokken,
   €14,36 i.p.v. €17,95, voorraad van het gewone product). Geen kortingscode nodig. Config: window.KIS_SOCKS_UPSELL (snippets/kis-socks-upsell.liquid), product live via /products/<handle>.js. */
(function () {
  var D = window.KIS_SOCKS_UPSELL;
  if (!D || window.KIS_UP_INIT || typeof window.fetch !== 'function') return;
  window.KIS_UP_INIT = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var origFetch = window.fetch;
  var modal = null;
  var selected = null;
  var busy = false;
  var lastFocus = null;

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function json(url, opts) {
    return origFetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      });
  }

  /* Meekijken met toevoegen aan winkelwagen (thema, snel kopen, bundels). */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|#|$)/.test(url)) {
      p.then(function (res) {
        if (!res || !res.ok) return;
        res.clone().json().then(onAdded).catch(function () {});
      }).catch(function () {});
    }
    return p;
  };

  function onAdded(data) {
    if (!data || data.status) return;
    var items = data.items || (data.handle ? [data] : []);
    if (!items.length) return;
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === D.handle || items[i].handle === D.dealHandle) return;
    }
    var sneaker = items.some(function (it) {
      return D.types.indexOf(String(it.product_type || '').toLowerCase()) !== -1;
    });
    if (!sneaker) return;
    Promise.all([loadProduct(), json(ROOT + 'cart.js', { method: 'GET' })])
      .then(function (res) {
        var ok = res[0], cart = res[1];
        var has = (cart.items || []).some(function (it) { return it.handle === D.handle || it.handle === D.dealHandle; });
        if (ok && !has) setTimeout(show, 700);
      })
      .catch(function () {});
  }

  /* Prijs, maten en voorraad live ophalen (Ajax API). */
  function loadProduct() {
    if (D.variants) return Promise.resolve(true);
    return json(ROOT + 'products/' + D.dealHandle + '.js', { method: 'GET' }).then(function (p) {
      if (!p || !p.available) return false;
      D.price = p.price;
      D.compare = p.compare_at_price || p.price;
      D.variants = (p.variants || []).map(function (v) {
        return { id: v.id, title: v.title, available: v.available };
      });
      if (!D.img && p.featured_image) D.img = p.featured_image;
      return true;
    }).catch(function () { return false; });
  }

  function build() {
    var pct = D.compare > D.price ? Math.round((1 - D.price / D.compare) * 100) : 0;
    modal = document.createElement('div');
    modal.className = 'kis-up';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'kis-up-title');
    var sizes = '';
    (D.variants || []).forEach(function (v) {
      sizes += '<button type="button" class="kis-up__size" data-kis-up-size="' + esc(v.id) + '"' +
        (v.available ? '' : ' disabled aria-label="' + esc(v.title) + ' uitverkocht"') + '>' + esc(v.title) + '</button>';
    });
    modal.innerHTML =
      '<div class="kis-up__panel">' +
      '<button type="button" class="kis-up__close" aria-label="Sluiten" data-kis-up-close>&times;</button>' +
      '<p class="kis-up__ok"><svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#1f8a4c"/><path d="M6 10.2l2.6 2.6L14.2 7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Toegevoegd aan je winkelwagen</p>' +
      '<h2 class="kis-up__title" id="kis-up-title">Sokken erbij?</h2>' +
      '<p class="kis-up__sub">Voeg ze nu toe en krijg 20% korting op de sokken.</p>' +
      '<div class="kis-up__prod"><div class="kis-up__thumb"><img src="' + esc(D.img || '') + '" alt=""></div>' +
      '<div><div class="kis-up__name">' + esc(D.title) + '</div>' +
      '<div class="kis-up__price">' + (pct ? '<s>' + money(D.compare) + '</s>' : '') + '<b>' + money(D.price) + '</b>' + (pct ? '<span class="kis-up__badge">-' + pct + '%</span>' : '') + '</div></div></div>' +
      '<p class="kis-up__label">Kies je maat</p>' +
      '<div class="kis-up__sizes" role="group" aria-label="Maat">' + sizes + '</div>' +
      '<button type="button" class="kis-up__atc" aria-disabled="true" data-kis-up-atc>Toevoegen met 20% korting</button>' +
      '<button type="button" class="kis-up__skip" data-kis-up-close>Nee, bedankt</button>' +
      '<p class="kis-up__msg" role="status" data-kis-up-msg></p>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-kis-up-close]')) { close(); return; }
      var s = e.target.closest('[data-kis-up-size]');
      if (s && !s.disabled) { pick(s); return; }
      if (e.target.closest('[data-kis-up-atc]')) add();
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = modal.querySelectorAll('button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function show() {
    if (modal && modal.classList.contains('is-open')) return;
    if (!modal) build();
    selected = null;
    lastFocus = document.activeElement;
    modal.querySelectorAll('[data-kis-up-size]').forEach(function (b) { b.classList.remove('is-active'); });
    modal.querySelector('[data-kis-up-atc]').setAttribute('aria-disabled', 'true');
    modal.querySelector('[data-kis-up-msg]').textContent = '';
    modal.classList.add('is-open');
    var first = modal.querySelector('[data-kis-up-size]:not([disabled])');
    (first || modal.querySelector('[data-kis-up-close]')).focus();
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus(); } catch (e) {}
    }
  }

  function pick(btn) {
    modal.querySelectorAll('[data-kis-up-size]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    selected = btn.getAttribute('data-kis-up-size');
    modal.querySelector('[data-kis-up-atc]').setAttribute('aria-disabled', 'false');
    modal.querySelector('[data-kis-up-msg]').textContent = '';
  }

  /* Dawn: winkelwagenlade verversen met de secties uit het /cart/add-antwoord (zelfde patroon als kis-pages.js). */
  function refreshDrawer(resp) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && resp && resp.sections) {
      drawer.renderContents(resp);
    } else if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else {
      location.href = ROOT + 'cart';
    }
    try {
      if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'kis-socks-upsell', productVariantId: selected });
    } catch (e) {}
  }

  function add() {
    var msg = modal.querySelector('[data-kis-up-msg]');
    var atc = modal.querySelector('[data-kis-up-atc]');
    if (!selected) { msg.textContent = 'Kies eerst je maat.'; return; }
    if (busy) return;
    busy = true;
    atc.textContent = 'Bezig met toevoegen...';
    var body = { items: [{ id: Number(selected), quantity: 1 }] };
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    json(ROOT + 'cart/add.js', { method: 'POST', body: JSON.stringify(body) })
      .then(function (resp) {
        if (resp && resp.status) throw new Error(resp.description || 'fout');
        close();
        refreshDrawer(resp);
      })
      .catch(function () {
        msg.textContent = 'Toevoegen lukte niet, probeer het opnieuw.';
      })
      .then(function () {
        busy = false;
        atc.textContent = 'Toevoegen met 20% korting';
      });
  }
})();
